import { useMemo, useEffect } from "react"
import { useCreatePaidInFullDocumentMutation, useDeleteDocumentMutation, usePaidInFullDocumentsQuery } from "src/api/api.generated"

export const usePaidInFullDocumentCRUD = (tenantId: string, propertyId: string, documentId?: string, customerId?: string) => {

  const { data: dataPaidInFullDocument, loading: loadingPaidInFullDocument } = usePaidInFullDocumentsQuery({
    variables: {
      filter: {
        tenantId: { eq: tenantId },
        propertyId: { eq: propertyId },
        id: { eq: documentId },
      },
    },
    skip: !documentId,
  })

  const { data: dataPaidInFullPendingDocuments, refetch, loading: paidInFullPendingDocuments } = usePaidInFullDocumentsQuery({
    variables: {
      filter: {
        tenantId: { eq: tenantId },
        propertyId: { eq: propertyId },
        customerId: { eq: customerId ?? null },
        draft: true
      },
    },
    skip: !customerId
  })

  useEffect(() => {
    refetch({
      filter: {
        tenantId: { eq: tenantId },
        documentType: "PAID_IN_FULL",
        propertyId: { eq: propertyId },
        customerId: { eq: customerId ?? null },
        draft: true
      }
    })
  }, [refetch, tenantId, propertyId, customerId])

  const [createPaidInFullDocument, { loading: loadingCreatePaidInFullDocument }] = useCreatePaidInFullDocumentMutation({ refetchQueries: ['Documents'] })

  const [deleteDocument, { loading: loadingDeleteDocument }] = useDeleteDocumentMutation({ refetchQueries: ['Documents'] })

  const loading = useMemo(() => {
    return loadingPaidInFullDocument || loadingCreatePaidInFullDocument || paidInFullPendingDocuments || loadingDeleteDocument
  }, [loadingPaidInFullDocument, loadingCreatePaidInFullDocument, paidInFullPendingDocuments, loadingDeleteDocument])

  return { dataPaidInFullDocument, createPaidInFullDocument, dataPaidInFullPendingDocuments, deleteDocument, loading }
}